import { GetApp } from "../../App"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { Icon, Icons } from "../../Components/Icon"
import { Loading } from "../../Components/Loading"
import { NewUserOverlay, ShipPersonEditView, ShipUserEditView } from "../ShipUserView"
import { GetShipData } from "./Context"
import { useShipUsersData } from "./UsersDataContext"
import { ShipDataUsersViewProps } from "./Params"

// Presentational crew roster for the ship_users tab. Reads the crew slices (roster +
// leveled/unleveled groupings) from the acquisition variant via `useShipUsersData()` and
// the static options / overlay state / manage permission from `GetShipData()`. Flag-
// agnostic: identical output whether the New (store) or Legacy (settings-bundle) variant
// supplied the data (issue #1186). The `<Loading/>` gate keys on `shipUsers === undefined`,
// which only the Legacy pre-load path produces -- the New path always has a resolved
// (possibly empty) roster, so it renders directly with no spinner.
export function UsersViewUI(_: ShipDataUsersViewProps) {
  const app = GetApp();
  const ts = app.getT("ShipSettingsView");
  const { ship, shipUserCrewRoleOptions, shipUserLevelOptions, newUserOverlay, setNewUserOverlay, shipUsersManageable } = GetShipData();
  const { shipUsers, leveledShipUsers, unleveledShipUsers } = useShipUsersData();
  return (
    <Block>

      {shipUsers == undefined ? <Loading /> : (
        <div className="centered_block_shipusers">

          <BlockRow className={`add_user_blockrow block-row-bottom-distance`}>
            <BlockField label={" "} className="button-at-input-level">
              <button className="button" onClick={() => setNewUserOverlay(true)}>
                <Icon icon={Icons.Plus} /> {ts("user_add_user")}
              </button>
            </BlockField>
          </BlockRow>

          {newUserOverlay && (
            <NewUserOverlay
              ship={ship}
              editable={shipUsersManageable}
              hideTypeSelection={!app.hasFeature("multi-user")}
              shipUserCrewRoleOptions={shipUserCrewRoleOptions}
              shipUserLevelOptions={shipUserLevelOptions}
              onClose={() => {
                setNewUserOverlay(false);
              }}
              t={ts}
            />
          )}

          <>
            <BlockRow>
              <h3>{ts("users_with_level")}</h3>
            </BlockRow>

            {leveledShipUsers.length > 0 && (
              <>
                <BlockRow className="ShipUserEditView-header">
                  <div className="block-field block_field_small_22_fix">{ts("user_name")}</div>
                  <div className="block-field block_field_small_10">{ts("user_shortname")}</div>
                  <div className="block-field block_field_small_10 status_field_desktop">{ts("user_status")}</div>
                </BlockRow>
                <BlockRow className="ShipUserEditView-header ShipUserEditView-2row">
                  <div className="block-field block_field_small_22_fix">{ts("ship_user_level")}</div>
                  <div className="block-field block_field_small_10">{ts("user_crew_role")}</div>
                  <div className="block-field block_field_small_10 status_field_mobile">{ts("user_status")}</div>
                  <div className="block-field button_top_distance_people">&nbsp;</div>
                </BlockRow>
              </>
            )}

            {leveledShipUsers.map((user) => (
              <ShipUserEditView key={user.id} editable={shipUsersManageable} user={user} shipUserCrewRoleOptions={shipUserCrewRoleOptions} shipUserLevelOptions={shipUserLevelOptions} ship={ship} />
            ))}

            <BlockRow className="margin-top-large">
              <h3>{ts("users_without_level")}</h3>
            </BlockRow>

            {unleveledShipUsers.length > 0 && (
              <>
                <BlockRow className="ShipUserEditView-header">
                  <div className="block-field block_field_small_22_fix">{ts("user_name")}</div>
                  <div className="block-field block_field_small_10">{ts("user_shortname")}</div>
                  <div className="block-field block_field_small_10">{ts("user_crew_role")}</div>
                  <div className="block-field">&nbsp;</div>
                </BlockRow>
              </>
            )}
            {unleveledShipUsers.map((user) => (
              <ShipPersonEditView key={user.id} editable={shipUsersManageable} user={user} shipUserCrewRoleOptions={shipUserCrewRoleOptions} shipUserLevelOptions={shipUserLevelOptions} ship={ship} />
            ))}
          </>

        </div>
      )}
    </Block>
  );
}
